import React, { useEffect } from 'react';

/**
 * Error dialog that stays put until the user dismisses it — ✕, Close, ESC or
 * a click on the backdrop. Nothing closes it on a timer, so a validation
 * failure cannot scroll past unread.
 */
export default function ErrorModal({ title = 'Please fix the following', messages = [], onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const list = Array.isArray(messages) ? messages : [messages];

  return (
    <div className="overlay" onClick={e => e.target.className === 'overlay' && onClose()}>
      <div className="modal modal-err" role="alertdialog" aria-modal="true" aria-label={title}>
        <button className="modal-x" onClick={onClose} aria-label="Close">✕</button>
        <div className="err-head">⚠️ {title}</div>
        <ul className="err-items">
          {list.map((m, i) => <li key={i}>{m}</li>)}
        </ul>
        <div className="modal-act">
          <button className="btn btn-p" onClick={onClose} autoFocus>Close</button>
        </div>
      </div>
    </div>
  );
}
